<form class="e2e-nysakskjema" [formGroup]="skjema">
  <fieldset class="tittel-rad">
    <mat-form-field class="tittel">
      <!--name="tittel" brukes i query selector-->
      <input matInput
             name="tittel"
             formControlName="tittel"
             [matAutocomplete]="saksmalerAutoCompl"
             (focus)="tittelfeltFokusert()"
             placeholder="{{'Tittel på ny sak'|translate}}"
             class="e2e-tittel"
             data-testid="tittel">
      <!--displayWith kan ikke benyttes for å sette korrekt verdi i tittel-feltet
      da displayWith ikke setter skjema.tittel, kun visningsverdien.
      skjema.tittel vil settes til saksmal-objekt angitt via mat-option.value
      saksforslagValgt vil så sette skjema.tittel til saksmal.tittel-->
      <mat-autocomplete #saksmalerAutoCompl="matAutocomplete"
                        panelWidth="400px"
                        class="saksmalertreff--valg e2e-søksak-resultatkontainer"
                        (optionSelected)="saksforslagValgt($event.option.value)">
        @if(saksmalertreff()?.malsaker?.length ?? 0 > 0){
          <mat-optgroup label="{{'Malsaker ({antall})'|translate:{antall:saksmalertreff()!.malsaker.length} }}">
            @for (malsak of saksmalertreff()!.malsaker; track malsak.id) {
              <mat-option [value]="malsak" matTooltip="{{'Malsak med sakstype \'{sakstype}\' og tema \'{tema}\''|translate:{sakstype:malsak.sakstype?.navn, tema:malsak.tema?.navn} }}">
                <div class="saksmal-tittel e2e-tittel">{{malsak.tittel}}</div>
                <div class="saksmal-beskrivelse" [innerHTML]="malsak.beskrivelse"></div>
              </mat-option>
            }
          </mat-optgroup>
        }
        @if(saksmalertreff()?.ordinaereSaker?.length ?? 0 > 0){
          <mat-optgroup label="{{'Eksisterende saker ({antall})'|translate:{antall:saksmalertreff()!.ordinaereSaker.length} }}" class="saker">
            @for (sak of saksmalertreff()!.ordinaereSaker; track sak.id) {
              <mat-option [value]="sak" matTooltip="{{'Eksisterende sak med sakstype \'{sakstype}\' og tema \'{tema}\''|translate:{sakstype:sak.sakstype, tema:sak.tema} }}">
                <span class="saksmal-møte">{{"Sak i {moetetittel} {moetenummer}, {moetedato}" | translate: {moetetittel:sak.moetetittel, moetenummer:sak.moetenummer, moetedato:sak.moetedato| zoneddatetime} }}</span>
                <div class="saksmal-tittel e2e-tittel">{{sak.saksnummer}} {{sak.tittel}}</div>
                <div class="saksmal-beskrivelse" [innerHTML]="sak.beskrivelse"></div>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
      @if (skjema.controls.tittel.hasError('maxlength')) {
        <mat-error data-testid="maxlength">{{skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="ansvarlig">
      <mat-label>{{ "Saksansvarlig"|translate }}</mat-label>
      <velg-medlem [medlemmer]="tilleggsdata().gruppemedlemmer" [skjemakontroll]="skjema.controls.ansvarlig" stil="kun-avatar" data-testid="ansvarlig"/>
    </mat-form-field>

    <button mat-button mat-stroked-button type="button" color="primary" (click)="visEllerSkjulDetaljer()" data-testid="vis-detaljer">
      <mat-icon>edit</mat-icon>
      @if(viserDetaljer){
        {{'Skjul detaljer'|translate}}
      } @else {
        {{'Detaljer'|translate}}
      }
    </button>
    <button (click)="slett()" mat-icon-button type="button" class="mat-medium-icon-button" data-testid="slett">
      <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
    </button>
  </fieldset>

  <div class="detaljer" [hidden]="!viserDetaljer" data-testid="detaljer">
    <span class="ramme-tittel">{{ "Detaljer"|translate }}</span>
    <fieldset class="attributter-rad">
      <fieldset class="tid-attributter">
        @if(erFlerdagsmoete()){
          <mat-form-field class="dag">
            <mat-label>{{ "Dag"|translate }}</mat-label>
            <velg-dag-fra-flerdagsmoete [skjemakontroll]="skjema.controls.dag" [moetedato]="moete().dato"/>
            @if(dagTidligereEnnForrigeSak()){
              <!--kan ikke bruker mat-error da denne betinger at vi reg feil på skjemakomp, noe vi ikke ønsker å gjøre i dette tilfellet
              fordi vi ikke ønsker å markere skjemat som ugyldig i denne situasjonen-->
              <mat-hint>Tidligere enn forrige sak</mat-hint>
            }
          </mat-form-field>

          @if(visStartklokkeslettvelger()){
            <mat-form-field class="startklokkeslett">
              <mat-label>{{ "Starttidspunkt dag {dag}"|translate: {dag: skjema.controls.dag.value!+1} }}</mat-label>
              <klokkeslett-velger formControlName="startklokkeslett"/>
              <mat-icon matPrefix fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon"></mat-icon>
            </mat-form-field>
          }
        }

        <mat-form-field class="varighet">
          <mat-label>{{ "Varighet"|translate }}</mat-label>
          <varighet-minutter-velger [skjemakontroll]="skjema.controls.varighet" data-testid="varighet"/>
          <mat-icon matPrefix fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon"></mat-icon>
        </mat-form-field>
      </fieldset>

      <mat-form-field>
        <mat-label>{{ "Sakstype"|translate }}</mat-label>
        <velg-sakstype [skjemakontroll]="skjema.controls.sakstype" [sakstyper]="tilleggsdata().sakstyper" visPausevalg="true"/>
      </mat-form-field>

      <mat-form-field class="tema">
        <mat-label>{{ "Tema"|translate }}</mat-label>
        <velg-tema [skjemakontroll]="skjema.controls.tema" [temaer]="tilleggsdata().temaer"/>
      </mat-form-field>

      <mat-form-field class="generert-dokument">
        <mat-label>{{ "Inkluder generert dokument"|translate }}</mat-label>
        <velg-generert-dokument [skjemakontroll]="skjema.controls.inkludertGenerertDokument"/>
      </mat-form-field>
    </fieldset>

    <mat-form-field class="beskrivelse">
      <mat-label>
        @if (!skjema.value.erPause) {
          {{ "Saksbeskrivelse"|translate }}
        } @else {
          {{ "Beskrivelse"|translate }}
        }
      </mat-label>
      <riktekst-redigering [skjemakontroll]="skjema.controls.beskrivelse" [gruppeId]="moete().eiendeGruppeId" innholdBrukesIPdf="true" data-testid="beskrivelse"/>
    </mat-form-field>

    @if(!skjema.value.erPause){
      <nye-beslutninger-skjema [skjema]="skjema.controls.beslutningsforslag" [gruppeId]="moete().eiendeGruppeId" data-testid="beslutningsforslag"/>
    }
  </div>
</form>
